export enum SvgIcon {
  Skift = 'skift',
  SkiftTwoArrow = 'skift_two_arrow',
  NavigationLogo = 'navigation logo',
  BurgerClose = 'burger close',
  Burger = 'burger',
  Calendar = 'calendar',
  Close = 'close',
  StateLocked = 'state locked',
  StateUnlocked = 'state unlocked',
  Search = 'search',
  DropdownArrow = 'dropdown arrow',
  DropdownMenuArrow = 'dropdown menu arrow',
  Guidance = 'guidance',
  Warning = 'warning',
  ErrorWarning = 'error_warning',
  WarningOutlined='warning_outlined',
  BookWhite = 'book-white',
  ArrowDropDownDefault = 'arrow_dropdown_default',
  ThreeDotVertical = 'three-dot-vertical',
  SortArrowInactive = 'sort_arrow_inactive',
  SortArrowDesc = 'sort_arrow_desc',
  SortArrowAsc = 'sort_arrow_asc',
  ArrowLeftDefault = 'arrow_left_default',
  ArrowRightDefault = 'arrow_right_default',
  ChevronDoubleLeft = 'chevron_double_left',
  ChevronDoubleRight = 'chevron_double_right',
  ChevronLeft = 'chevron_left',
  ChevronRight = 'chevron_right',
  ChevronDown = 'chevron_down',
  ChevronUp = 'chevron_up',
  Filter = 'filter',
  FullScreen = 'full_screen',
  Download = 'download',
  Print = 'print',
  DragDropIndicator = 'dragdrop_indicator',
  NavigationBackIcon = 'navigation_back_icon',
  TimeIcon = 'time_icon',
  Trash = 'trash',
  PointingDownBracket= 'pointing_down_bracket_icon',
  Questionmark= 'questionmark',
  QuestionmarkOutlined= 'questionmark_outlined',
  EyeClose= 'eye_close',
  EyeOpen= 'eye_open',
  SaveConfirmed='save_confirmed',
  GuideRightArrow='guide_right_arrow',
  GuideLeftArrow='guide_left_arrow',
  GuideOpenInWindow='guide_open_in_window',
  Info='info',
  InfoOutlined='info_outlined',
  PaginationEllipsis='pagination_ellipsis',
  Error='error',
  Checkmark='checkmark',
  CheckmarkFilled='checkmark_filled',
  GreenCheckCircle='green_check_circle',
  RedErrorCircle='red_error_circle',
  User='user',
  Go = 'right_arrow_circle_dark',
  IconCircleCheck = "icon-circle-check",
  ExternalLink = "external_link",
  BackArrow = "back_arrow",
  TopArrow = "top_arrow"
}
const SVG_DEFAULT_URL = window.location.origin + '/assets/images/';

export function getSvgIconData(baseUrl?: string): {[key in SvgIcon]: string} {
  const SVG_BASE_URL = baseUrl ?? SVG_DEFAULT_URL;
  return {
    [SvgIcon.Skift]: SVG_BASE_URL + 'skift_icon.svg',
    [SvgIcon.GreenCheckCircle]: SVG_BASE_URL + 'green_check_circle.svg',
    [SvgIcon.RedErrorCircle]: SVG_BASE_URL + 'red_error_circle.svg',
    [SvgIcon.SkiftTwoArrow]: SVG_BASE_URL + 'skift_two_arrow.svg',
    [SvgIcon.NavigationLogo]: SVG_BASE_URL + 'VALG_logo_white.svg',
    [SvgIcon.Burger]: SVG_BASE_URL + 'burger_icon.svg',
    [SvgIcon.BurgerClose]: SVG_BASE_URL + 'burger_close_icon.svg',
    [SvgIcon.Calendar]: SVG_BASE_URL + 'calendar.svg',
    [SvgIcon.Close]: SVG_BASE_URL + 'close.svg',
    [SvgIcon.StateLocked]: SVG_BASE_URL + 'state_locked_icon.svg',
    [SvgIcon.StateUnlocked]: SVG_BASE_URL + 'state_unlocked_icon.svg',
    [SvgIcon.BookWhite]: SVG_BASE_URL + 'book.svg',
    [SvgIcon.ArrowDropDownDefault]: SVG_BASE_URL + 'arrow_dropdown_default.svg',
    [SvgIcon.Search]: SVG_BASE_URL + 'search_icon.svg',
    [SvgIcon.DropdownArrow]: SVG_BASE_URL + 'dropdown_arrow_icon.svg',
    [SvgIcon.DropdownMenuArrow]: SVG_BASE_URL + 'dropdown_menu_arrow_icon.svg',
    [SvgIcon.Guidance]: SVG_BASE_URL + 'guidance_icon.svg',
    [SvgIcon.Warning]: SVG_BASE_URL + 'warning_icon.svg',
    [SvgIcon.ErrorWarning]: SVG_BASE_URL + 'error_warning_icon.svg',
    [SvgIcon.WarningOutlined]: SVG_BASE_URL + 'warning_outlined.svg',
    [SvgIcon.ThreeDotVertical]: SVG_BASE_URL + 'three_dot_vertical.svg',
    [SvgIcon.SortArrowInactive]: SVG_BASE_URL + 'sort_arrow_inactive.svg',
    [SvgIcon.SortArrowDesc]: SVG_BASE_URL + 'sort_arrow_desc.svg',
    [SvgIcon.SortArrowAsc]: SVG_BASE_URL + 'sort_arrow_asc.svg',
    [SvgIcon.ArrowLeftDefault]: SVG_BASE_URL + 'arrow_left_default.svg',
    [SvgIcon.ArrowRightDefault]: SVG_BASE_URL + 'arrow_right_default.svg',
    [SvgIcon.ChevronDoubleLeft]: SVG_BASE_URL + 'chevron_double_left.svg',
    [SvgIcon.ChevronDoubleRight]: SVG_BASE_URL + 'chevron_double_right.svg',
    [SvgIcon.ChevronLeft]: SVG_BASE_URL + 'chevron_left.svg',
    [SvgIcon.ChevronRight]: SVG_BASE_URL + 'chevron_right.svg',
    [SvgIcon.ChevronDown]: SVG_BASE_URL + 'chevron_down.svg',
    [SvgIcon.ChevronUp]: SVG_BASE_URL + 'chevron_up.svg',
    [SvgIcon.Filter]: SVG_BASE_URL + 'filter.svg',
    [SvgIcon.FullScreen]: SVG_BASE_URL + 'full_screen.svg',
    [SvgIcon.Download]: SVG_BASE_URL + 'download.svg',
    [SvgIcon.Print]: SVG_BASE_URL + 'print.svg',
    [SvgIcon.DragDropIndicator]: SVG_BASE_URL + 'dragdrop_indicator.svg',
    [SvgIcon.NavigationBackIcon]: SVG_BASE_URL + 'navigation_back_icon.svg',
    [SvgIcon.TimeIcon]: SVG_BASE_URL + 'time_icon.svg',
    [SvgIcon.Trash]: SVG_BASE_URL + 'trashbin.svg',
    [SvgIcon.PointingDownBracket]: SVG_BASE_URL + 'pointing_down_bracket_icon.svg',
    [SvgIcon.Questionmark]: SVG_BASE_URL + 'questionmark.svg',
    [SvgIcon.QuestionmarkOutlined]: SVG_BASE_URL + 'questionmark_outlined.svg',
    [SvgIcon.EyeOpen]: SVG_BASE_URL + 'eye_open.svg',
    [SvgIcon.EyeClose]: SVG_BASE_URL + 'eye_close.svg',
    [SvgIcon.SaveConfirmed]: SVG_BASE_URL + 'save_confirmed.svg',
    [SvgIcon.GuideRightArrow]: SVG_BASE_URL + 'guide_right_arrow.svg',
    [SvgIcon.GuideLeftArrow]: SVG_BASE_URL + 'guide_left_arrow.svg',
    [SvgIcon.GuideOpenInWindow]: SVG_BASE_URL + 'guide_open_in_window.svg',
    [SvgIcon.Info]: SVG_BASE_URL + 'info.svg',
    [SvgIcon.InfoOutlined]: SVG_BASE_URL + 'info_outlined.svg',
    [SvgIcon.PaginationEllipsis]: SVG_BASE_URL + 'pagination_ellipsis.svg',
    [SvgIcon.Error]: SVG_BASE_URL + 'error.svg',
    [SvgIcon.Checkmark]: SVG_BASE_URL + 'checkmark.svg',
    [SvgIcon.User]: SVG_BASE_URL + 'user.svg',
    [SvgIcon.CheckmarkFilled]: SVG_BASE_URL + 'checkmark_filled.svg',
    [SvgIcon.Go]: SVG_BASE_URL + 'right_arrow_circle_dark.svg',
    [SvgIcon.IconCircleCheck]: SVG_BASE_URL + 'icon-circle-check.svg',
    [SvgIcon.ExternalLink]: SVG_BASE_URL + 'external_link_icon.svg',
    [SvgIcon.BackArrow]: SVG_BASE_URL + 'back_arrow_icon.svg',
    [SvgIcon.TopArrow]: SVG_BASE_URL + 'top_arrow.svg'
  }
}
